import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../../../omaLummeContext';
import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';

// Utils.
import { validateEmail } from '../../../../utils/contact';
import ManageContractsAddressFields from '../ManageContractsAddressFields';
import { generateAddress } from '../../../../utils/address';

export const eBillBanks = [
  'Aktia Pankki',
  'Danske Bank',
  'Handelsbanken',
  'Nordea',
  'Osuuspankki',
  'POP Pankki',
  'S-pankki',
  'Säästöpankki',
  'Ålandsbanken',
];

export const Billing: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { users } = OmaLummeApp.useState();
  const { filteredContracts, filteredLedgers, selectedForm, selectedForm4, oldContract, payment, changePrimaryAddress, newAddress, useVaihtoturva } =
    ManageContractsApp.useState();

  const { paymentType, paymentTypeEbillBank, paymentTypeNewEmail, paymentTypeNewEmailValid, paymentTypeNewAddress } = payment;

  const { activeUser } = users;

  const emailExists = activeUser.userEmail && activeUser.userEmail.length > 0;

  const userHasPaperLedgers =
    filteredLedgers.filter((l) => l.paymentType?.paymentTypeNo !== 3 && l.paymentType?.paymentTypeNo !== 20).length > 0 ? true : false;
  const oldContractPaymentType = oldContract
    ? filteredLedgers.find((l) => l.ledgerNo === oldContract?.ledgerNo)?.paymentType?.paymentTypeNo
    : undefined;

  if (
    !(
      selectedForm4 === 1 &&
      filteredLedgers.length > 0 &&
      (!userHasPaperLedgers || !(oldContractPaymentType && oldContractPaymentType !== 3 && oldContractPaymentType !== 20))
    ) &&
    !(
      useVaihtoturva &&
      useVaihtoturva.length > 0 &&
      oldContract &&
      filteredLedgers.find((l) => l.ledgerNo === oldContract.ledgerNo)?.paymentType?.paymentTypeNo === 3
    )
  ) {
    return (
      <section className="manage-contracts-step stepInvoice">
        {!(selectedForm === 4 && selectedForm4 === 2) && <h3>{t('manageContracts:manageContracts.InvoiceTitle')}*</h3>}
        {selectedForm === 4 && selectedForm4 === 2 && <h3>{t('manageContracts:manageContracts.InvoiceChangeTitle')}*</h3>}

        <div className="form-items">
          <h4>{t('billing:paymentTypes.eBill')}</h4>
          <ManageContractsRadio
            radioID="paymentTypeEbill"
            radioName="paymentType"
            onChangeFunc={(): void => {
              dispatch(['changePayment', { ...payment, paymentType: 'eBill', paymentTypeNewEmailValid: true }]);
              if (
                document.querySelector('input[id="paymentTypeEbill"]:checked') &&
                (paymentTypeEbillBank === undefined || paymentTypeEbillBank === 'null')
              ) {
                dispatch(['changePayment', { ...payment, paymentType: 'eBill', paymentTypeEbillValid: false }]);
              }
            }}
            checkedComparison={paymentType === 'eBill'}
            label={`${t('manageContracts:manageContracts.InvoiceEbill')}`}
          />
          {paymentType === 'eBill' && (
            <div className="form-item-sub-content select select-ghost">
              <select
                id="address"
                value={paymentTypeEbillBank}
                onChange={(event): void => {
                  if (event.target.value !== 'null') {
                    dispatch(['changePayment', { ...payment, paymentTypeEbillBank: event.target.value, paymentTypeEbillValid: true }]);
                  } else {
                    dispatch(['changePayment', { ...payment, paymentTypeEbillValid: false }]);
                  }
                }}
              >
                <option value="null">{t('manageContracts:manageContracts.InvoiceEbillSelectBank')}</option>
                {eBillBanks.map((bank) => (
                  <option key={bank} value={bank}>
                    {bank}
                  </option>
                ))}
              </select>
            </div>
          )}
          <h4>{t('billing:paymentTypes.email')}</h4>
          {emailExists && (
            <ManageContractsRadio
              radioID="paymentTypeEmailMyAddress"
              radioName="paymentType"
              onChangeFunc={(): void => {
                dispatch([
                  'changePayment',
                  { ...payment, paymentType: 'emailMyAddress', paymentTypeEbillValid: true, paymentTypeNewEmailValid: true },
                ]);
              }}
              checkedComparison={paymentType === 'emailMyAddress'}
              label={`${t('manageContracts:manageContracts.InvoiceEmailMyAddress')} <strong>${activeUser.userEmail}</strong>`}
            />
          )}
          <ManageContractsRadio
            radioID="paymentTypeEmailNewAddress"
            radioName="paymentType"
            onChangeFunc={(): void => {
              dispatch(['changePayment', { ...payment, paymentType: 'emailNewAddress', paymentTypeNewEmailValid: true }]);
              if (
                document.querySelector('input[id="paymentTypeEmailNewAddress"]:checked') &&
                (!paymentTypeNewEmail || (paymentTypeNewEmail && !validateEmail(paymentTypeNewEmail)))
              ) {
                dispatch(['changePayment', { ...payment, paymentType: 'emailNewAddress', paymentTypeNewEmailValid: false }]);
              }
            }}
            checkedComparison={paymentType === 'emailNewAddress'}
            label={`${t(
              emailExists ? 'manageContracts:manageContracts.InvoiceEmailNewAddress' : 'manageContracts:manageContracts.InvoiceEmailMyAddress',
            )}`}
          />
          {paymentType === 'emailNewAddress' && (
            <div className="form-item-sub-content paymentTypeEmailNewAddressInput">
              <label htmlFor="paymentTypeEmailNewAddressInput">{t('common:general.email')}*</label>
              <input
                type="email"
                id="paymentTypeEmailNewAddressInput"
                name="email"
                value={paymentTypeNewEmail}
                onChange={(e): void => {
                  const emailIsValid = validateEmail(e.target.value);
                  if (emailIsValid) {
                    dispatch(['changePayment', { ...payment, paymentTypeNewEmail: e.target.value, paymentTypeNewEmailValid: true }]);
                  } else {
                    dispatch(['changePayment', { ...payment, paymentTypeNewEmail: e.target.value, paymentTypeNewEmailValid: false }]);
                  }
                }}
                required
              />
              {!paymentTypeNewEmailValid && <strong>{t('common:contactform.email')}</strong>}
            </div>
          )}
          {selectedForm4 !== 2 && (
            <>
              <h4>{t('billing:paymentTypes.paper')}</h4>

              {((changePrimaryAddress && newAddress) || activeUser.userAddress[0]) && (
                <ManageContractsRadio
                  radioID="paymentTypePaperMyAddress"
                  radioName="paymentType"
                  onChangeFunc={(): void => {
                    dispatch([
                      'changePayment',
                      { ...payment, paymentType: 'paperMyAddress', paymentTypeEbillValid: true, paymentTypeNewEmailValid: true },
                    ]);
                  }}
                  checkedComparison={paymentType === 'paperMyAddress'}
                  label={`${t('manageContracts:manageContracts.InvoicePaperMyAddress')} <strong>${
                    changePrimaryAddress && newAddress ? generateAddress(newAddress, false) : generateAddress(activeUser.userAddress[0], false)
                  }</strong>`}
                />
              )}
              <ManageContractsRadio
                radioID="paymentTypePaperNewAddress"
                radioName="paymentType"
                onChangeFunc={(): void => {
                  dispatch([
                    'changePayment',
                    { ...payment, paymentType: 'paperNewAddress', paymentTypeEbillValid: true, paymentTypeNewEmailValid: true },
                  ]);
                }}
                checkedComparison={paymentType === 'paperNewAddress'}
                label={`${t('manageContracts:manageContracts.InvoicePaperNewAddress')}`}
              />
              {paymentType === 'paperNewAddress' && (
                <div className="form-item-sub-content">
                  <p>{t('manageContracts:manageContracts.MultipleOwnersYesBody')}</p>

                  <ManageContractsAddressFields
                    address={paymentTypeNewAddress}
                    action="changePayment"
                    showNameFields={false}
                    showSSN={false}
                    showMobilePhoneNumber={false}
                  />
                </div>
              )}
            </>
          )}
        </div>
        {filteredContracts.length > 1 && <p>{t('manageContracts:manageContracts.CheckAndUpdateOtherContracts')}</p>}
      </section>
    );
  }
  return <></>;
};

export default Billing;
